module.exports = __webpack_public_path__ + "static/img/aifeizixun.f5341ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/aifeizixun.jpg
// module id = 9gQg
// module chunks = 1